import { Paper, Typography, Box } from "@mui/material";
import { USCurrency } from "../../types";

const Unbudget = (props: any) => {
	return (
		<Paper elevation={0} sx={{ mb: 1, borderRadius: 2, p: 2, background: 'white', color: 'inherit' }} onClick={props.OnClick}>
			<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
				<Typography variant="h6" sx={{ fontWeight: 600 }}>{USCurrency(props.Total)} Unbudgeted</Typography>
			</Box>
			<Typography variant="body2">Since {props.Since.toString()}</Typography>
		</Paper>
	);
}

export default Unbudget;